import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import MapHelper from "@Scripts/Infrastructure/MapHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CenterList" })
export default class CenterList extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public errorPromise: any = null;
    public errors: any[] = [];
    public centers: any[] = [];
    public markers: any[] = [];
    public isUserZoom: boolean = false;

    @Prop() readonly markets: string[];

    public defaultAccuracy = 35000;

    get routes() {
        return (<any>window).App.routes;
    }

    public mounted() {
        this.$nextTick(function () {
            MapHelper.init();
            this.initMap();
        });
    }

    public async initMap() {
        let self = this;

        MapHelper.mapBox.on("movestart", function () {
        });

        MapHelper.mapBox.on("idle", async function () {
            await self.getGeoMarkers();
        });

        await this.getGeoMarkers();
    }

    public centerUserLocation() {
        this.clearErrors();
        this.isUserZoom = false;

        if (!MapHelper.centerToUserLocation()) {
            this.errors.push(this.localizer.get("WhereToBuy.Common.Error_NoGeolocation"));

            clearTimeout(this.errorPromise);
            this.errorPromise = setTimeout(function () {
                this.clearErrors();
            }, 3000);
        }
    }

    public findUserLocation() {
        this.clearErrors();

        navigator.geolocation.getCurrentPosition(function (success) {
            var coords = new (<any>window).mapboxgl.LngLat(success.coords.longitude, success.coords.latitude);
            MapHelper.centerMap(coords);
        }, function (error) {
            this.errors.push(this.localizer.get("WhereToBuy.Common.Error_NoGeolocation"));

            clearTimeout(this.errorPromise);
            this.errorPromise = setTimeout(function () {
                this.clearErrors();
            }, 3000);
        }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });
    }

    public async getGeoMarkers(mapBounds = null) {
        mapBounds = !mapBounds ? MapHelper.mapBox.getBounds() : mapBounds;

        var centerSearch = {
            markets: this.markets,
            topRightLatitude: mapBounds._ne.lat,
            topRightLongitude: mapBounds._ne.lng,
            bottomLeftLatitude: mapBounds._sw.lat,
            bottomLeftLongitude: mapBounds._sw.lng
        };

        let response = await Axios.post(this.routes.Center_GetCenters, centerSearch, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
        if (response.data) {
            this.centers = response.data;
            this.markers = [];

            for (var i = 0, l = response.data.length; i < l; i++) {
                let item = response.data[i];
                let description: string = "";

                description += "<div class=\"infowindow-title\">" + item.company + "</div><div class=\"infowindow-description\">" + item.address + "<br />" + item.postCode + " " + item.location + "<br />" + item.zone + " " + "(" + item.country + ")<br />";

                if (item.phone) {
                    description += "<br />Tel. " + item.phone;
                }

                if (item.email) {
                    description += "<br />Email <a href=\"mailto:" + item.email + "\">" + item.email + "</a>";
                }

                if (item.websiteUrl) {
                    description += "<br />Website <a href=\"" + item.websiteUrl + "\" target=\"_blank\">" + item.websiteUrl + "</a>";
                }

                description += "</div>";

                var markerElement = document.createElement("div");
                markerElement.className = "map-marker";
                markerElement.setAttribute("data-company", item.company);

                let lngLat = new (<any>window).mapboxgl.LngLat(item.longitude, item.latitude);
                let popUp = new (<any>window).mapboxgl.Popup().setHTML(description);

                var marker = new (<any>window).mapboxgl.Marker(markerElement).setLngLat(lngLat).setPopup(popUp).addTo(MapHelper.mapBox);

                this.markers.push(marker);
            }
        }
    }

    public clearAutocomplete() {
        this.clearErrors();
    }

    public clearErrors() {
        this.errors = [];
    }

    public cleanText(text: string) {
        return text.replace("&amp;", "&");
    };

    public getGeoaddressLink(marker: any) {
        var query = marker.Address + " " + marker.Location + " " + marker.Zone + " " + marker.PostCode + " " + marker.Country;
        var url = "maps://?q=";
        return url + query;
    }

    public centerMarker(marker) {
        MapHelper.centerMap(new (<any>window).mapboxgl.LngLat(marker.longitude, marker.latitude));
        window.scroll({ top: 0, behavior: "smooth" });
    };

    public website(company: string) {
        GTagHelper.sendEvent("click", "locator", "website_" + company );
    }
    
    public email(company: string) {
        GTagHelper.sendEvent("click", "locator", "email_" + company );
    }
    
    public phone(company: string) {
        GTagHelper.sendEvent("click", "locator", "phone_" + company );
    }
};